"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ResourceLogModel", {
    enumerable: true,
    get: function() {
        return ResourceLogModel;
    }
});
const _zod = require("zod");
const _resources = require("./resources");
const ResourceLogModel = _zod.z.discriminatedUnion("resource_type", [
    _resources.AutoflowResourceLog,
    _resources.ReviewCycleResourceLog,
    _resources.EtlManualTriggerResourceLog,
    _resources.ScimResourceLog,
    _resources.SurveyResourceLog,
    _resources.UserDeactivationResourceLog
]);
